import { createContext } from 'react';

// Shared by the Reports page, DataTable, drill-down drawer and the Payroll Workbench.
export const ReportCtx = createContext({ onDrill: null, company: null, user: null, period: '', token: null });
